export const FEATURED_PRODUCT_REQUEST = "FEATURED_PRODUCT_REQUEST";
export const FEATURED_PRODUCT_SUCCESS = "FEATURED_PRODUCT_SUCCESS";
export const FEATURED_PRODUCT_FAIL = "FEATURED_PRODUCT_FAIL";

export const ALL_PRODUCT_REQUEST = "ALL_PRODUCT_REQUEST";
export const ALL_PRODUCT_SUCCESS = "ALL_PRODUCT_SUCCESS";
export const ALL_PRODUCT_FAIL = "ALL_PRODUCT_FAIL";

export const SINGLE_PRODUCT_REQUEST = "SINGLE_PRODUCT_REQUEST";
export const SINGLE_PRODUCT_SUCCESS = "SINGLE_PRODUCT_SUCCESS";
export const SINGLE_PRODUCT_FAIL = "SINGLE_PRODUCT_FAIL";

export const NEW_ARRIVAL_PRODUCT_REQUEST = "NEW_ARRIVAL_PRODUCT_REQUEST";
export const NEW_ARRIVAL_PRODUCT_SUCCESS = "NEW_ARRIVAL_PRODUCT_SUCCESS";
export const NEW_ARRIVAL_PRODUCT_FAIL = "NEW_ARRIVAL_PRODUCT_FAIL";

export const HOT_PRODUCT_REQUEST = "HOT_PRODUCT_REQUEST";
export const HOT_PRODUCT_SUCCESS = "HOT_PRODUCT_SUCCESS";
export const HOT_PRODUCT_FAIL = "HOT_PRODUCT_FAIL";

export const ADD_TO_CART_SUCCESS = "ADD_TO_CART_SUCCESS";
export const REMOVE_FROM_CART = "REMOVE_FROM_CART";

export const USER_SIGNUP_REQUEST = "USER_SIGNUP_REQUEST";
export const USER_SIGNUP_SUCCESS = "USER_SIGNUP_SUCCESS";
export const USER_SIGNUP_FAIL = "USER_SIGNUP_FAIL";

export const LOG_IN_REQUEST = "LOG_IN_REQUEST";
export const LOG_IN_SUCCESS = "LOG_IN_SUCCESS";
export const LOG_IN_FAIL = "LOG_IN_FAIL";
export const LOG_OUT_USER = "LOG_OUT_USER";

export const USER_DETAILS_REQUEST = "USER_DETAILS_REQUEST";
export const USER_DETAILS_SUCCESS = "USER_DETAILS_SUCCESS";
export const USER_DETAILS_FAIL = "USER_DETAILS_FAIL";

export const USER_UPDATE_REQUEST = "USER_UPDATE_REQUEST";
export const USER_UPDATE_SUCCESS = "USER_UPDATE_SUCCESS";
export const USER_UPDATE_FAIL = "USER_UPDATE_FAIL";
export const SAVE_SHIPPING_INFO = "SAVE_SHIPPING_INFO";
export const USER_UPDATE_RESET = "USER_UPDATE_RESET";

export const NEW_ORDER_REQUEST = "NEW_ORDER_REQUEST";
export const NEW_ORDER_SUCCESS = "NEW_ORDER_SUCCESS";
export const NEW_ORDER_FAIL = "NEW_ORDER_FAIL";
export const ORDER_COMPLETE_AND_RESET_CART = "ORDER_COMPLETE_AND_RESET_CART";

export const ORDER_DETAILS_REQUEST = "ORDER_DETAILS_REQUEST";
export const ORDER_DETAILS_SUCCESS = "ORDER_DETAILS_SUCCESS";
export const ORDER_DETAILS_FAIL = "ORDER_DETAILS_FAIL";

export const ORDER_UPDATE_REQUEST = "ORDER_UPDATE_REQUEST";
export const ORDER_UPDATE_SUCCESS = "ORDER_UPDATE_SUCCESS";
export const ORDER_UPDATE_FAIL = "ORDER_UPDATE_FAIL";
export const ORDER_RESET = "ORDER_RESET";

export const USER_ORDER_REQUEST = "USER_ORDER_REQUEST";
export const USER_ORDER_SUCCESS = "USER_ORDER_SUCCESS";
export const USER_ORDER_FAIL = "USER_ORDER_FAIL";

export const ADMIN_ORDER_REQUEST = "ADMIN_ORDER_REQUEST";
export const ADMIN_ORDER_SUCCESS = "ADMIN_ORDER_SUCCESS";
export const ADMIN_ORDER_FAIL = "ADMIN_ORDER_FAIL";
